module.exports = {"id":"197225","name":"Nicolás Lodeiro","rating":"78","photo":"./data/images/photos/3/197225.png","club":{"name":"Seattle Sounders","logo":"./data/images/clubs/SeattleSounders.png"},"positions":["MD","MOC","ATT"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/NicolasLodeiro0.json
// module id = 3200
// module chunks = 0